'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// const { JSDOM } = jsdom;
// eslint-disable-next-line import/no-unresolved


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var _saveUserData = require('redux/modules/saveUserData');

var _semanticUiReact = require('semantic-ui-react');

require('./ImageRenderer.css');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IMAGE_PLACEHOLDER = "https://live.staticflickr.com/8287/29517736620_3184b66ec8.jpg";

var ImageRenderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    ReactGA: state.company.ReactGA,
    design_template_name: state.templateData.design_template_name,
    content_template_name: state.templateData.content_template_name,
    uploaded_image_url: state.templateData.uploaded_image_url,
    uploaded_image_index: state.templateData.uploaded_image_index
  };
}, {
  updateInfo: templateData.updateField,
  uploadImage: templateData.uploadImage,
  saveUserData: _saveUserData.save
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ImageRenderer, _Component);

  function ImageRenderer(props) {
    (0, _classCallCheck3.default)(this, ImageRenderer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImageRenderer.__proto__ || (0, _getPrototypeOf2.default)(ImageRenderer)).call(this, props));

    _this.state = {
      accepted: [],
      rejected: [],
      value: _this.props.src,
      imageIndex: _this.props.imageIndex
    };
    return _this;
  }

  (0, _createClass3.default)(ImageRenderer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.src != this.props.src) {
        this.setState({ value: this.props.src });
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus(event, type) {
      this.props.ReactGA.event({
        category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
        action: 'Edit: ' + type,
        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      });
    }
  }, {
    key: 'onDrop',
    value: function onDrop(accepted, rejected) {
      var _this2 = this;

      accepted.forEach(function (file) {
        var reader = new FileReader();
        reader.onload = function () {
          var fileAsBinaryString = reader.result;
          // do whatever you want with the file content
          _this2.props.handleUpload({ image: fileAsBinaryString, name: file.name, image_index: _this2.state.imageIndex });
        };
        reader.onabort = function () {
          return console.log('file reading was aborted');
        };
        reader.onerror = function () {
          return console.log('file reading has failed');
        };

        reader.readAsDataURL(file);
      });
      this.setState({ accepted: accepted, rejected: rejected });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'modalImageWrapperDiv', style: { width: '200px' } },
        _react2.default.createElement(
          _reactDropzone2.default,
          {
            multiple: false,
            accept: 'image/jpeg, image/png',
            maxSize: 400000,
            onFocus: function onFocus(event) {
              return _this3.onFocus(event, 'Image Upload');
            },
            onDrop: function onDrop(accepted, rejected) {
              return _this3.onDrop(accepted, rejected);
            }
          },
          this.state.value && _react2.default.createElement('img', { src: this.state.value }),
          !this.state.accepted && _react2.default.createElement(
            'p',
            null,
            'Only *.jpeg and *.png images will be accepted'
          ),
          this.state.rejected.map(function (f) {
            if (f.size > 400000) {
              return _react2.default.createElement(
                'li',
                { key: f.name },
                'Upload an image less than 400 kb'
              );
            } else {
              return _react2.default.createElement(
                'li',
                { key: f.name },
                'Rejected ',
                f.name,
                ' as it is not png or jpeg'
              );
            }
          })
        )
      );
    }
  }]);
  return ImageRenderer;
}(_react.Component)) || _class);
exports.default = ImageRenderer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageRenderer/ImageRenderer.js
// module id = 1736
// module chunks = 0